import { IError } from '../../types/error';
import { IApplicationState } from '../../types/redux';

export const selectError = (state: IApplicationState): IError | null => {
  return state.error;
};
